import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import HTTPMethod from 'http-method-enum';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { FlyoutButtonPanelWrapper } from '@poplar/components/Flyout/FlyoutTodo/common';
import { Text, Title } from '@yoweb/ui/components/typography';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { Flex } from '@yoweb/ui/components/Flex';
import { CheckYellowBackground } from '@yoweb/ui/components/Icon';
import { Grid } from '@yoweb/ui/components/Grid';
import { th } from '@yoweb/ui/styles/utils/theme';
import { Button } from '@yoweb/ui/components/buttons';
import { URL_CHECKOUT_ONBOARDING } from '@poplar/constants/urls';
import { ErrorDisplay, useError } from '@yoweb/ui/components/form';
import { API_USER_FINISH_ONBOARDING, PAGE_HOME } from '@poplar/constants/routes';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Subscribe = function Subscribe(_ref) {
  var saveTask = _ref.saveTask,
      handleSaveDraft = _ref.handleSaveDraft;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useExternalConfig = useExternalConfig(),
      baseStoreUrl = _useExternalConfig.baseStoreUrl,
      globalFeatures = _useExternalConfig.globalFeatures;

  var router = useRouter();
  var errorDisplay = useError();

  var _useState = useState(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var subBenefits = t('todo-promo-summary.sub-benefits', {
    returnObjects: true
  });
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
    "data-testid": "step-subscribe",
    children: [/*#__PURE__*/_jsxs(Grid, {
      gap: "normal2",
      children: [/*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
        withBorder: true,
        backgroundColor: "base000"
      }, errorDisplay), {}, {
        "data-testid": "error-banner"
      })), /*#__PURE__*/_jsx(Text, {
        children: t('todo-promo-summary.subtitle')
      }), /*#__PURE__*/_jsxs(SubscriptionCard, {
        display: "grid",
        gap: "normal1",
        backgroundColor: "base000",
        p: "normal3",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Title, {
            size: "md",
            weight: "regular",
            children: t('todo-promo-summary.price')
          }), /*#__PURE__*/_jsx(Text, {
            children: t('todo-promo-summary.price-description')
          })]
        }), /*#__PURE__*/_jsxs(Grid, {
          gap: "small4",
          children: [/*#__PURE__*/_jsx(Title, {
            size: "xs",
            children: t('todo-promo-summary.sub-benefits-title')
          }), subBenefits.map(function (benefit, i) {
            return (
              /*#__PURE__*/
              // eslint-disable-next-line react/no-array-index-key
              _jsxs(Flex, {
                gap: "small4",
                children: [/*#__PURE__*/_jsx(CheckYellowBackground, {
                  size: 22
                }), /*#__PURE__*/_jsx(Text, {
                  children: benefit
                })]
              }, "benefit-".concat(i))
            );
          })]
        }), /*#__PURE__*/_jsx(Text, {
          children: t('todo-promo-summary.pause-cancel')
        })]
      })]
    }), /*#__PURE__*/_jsxs(FlyoutButtonPanelWrapper, {
      children: [/*#__PURE__*/_jsx(Button, {
        size: "lg",
        isLoading: isSubmitting,
        "data-testid": "subscribe-step-btn",
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var savedTaskId;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  errorDisplay.clear();
                  setIsSubmitting(true);
                  _context.prev = 2;
                  _context.next = 5;
                  return saveTask();

                case 5:
                  savedTaskId = _context.sent;

                  if (!savedTaskId) {
                    _context.next = 10;
                    break;
                  }

                  void fetchJson(API_USER_FINISH_ONBOARDING, {
                    method: HTTPMethod.POST,
                    body: JSON.stringify({
                      isPoplarSignupFlowDisplayed: true
                    })
                  });
                  _context.next = 10;
                  return router.push(URL_CHECKOUT_ONBOARDING(baseStoreUrl, i18n.language, savedTaskId));

                case 10:
                  _context.next = 16;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](2);
                  errorDisplay.set();
                  throw _context.t0;

                case 16:
                  _context.prev = 16;
                  setIsSubmitting(false);
                  return _context.finish(16);

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 12, 16, 19]]);
        })),
        children: t('actions.continue')
      }), globalFeatures.enableDoThisLater && /*#__PURE__*/_jsx(Box, {
        display: "flex",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(Button, {
          size: "lg",
          variant: "tertiary",
          "data-testid": "do-this-later-btn",
          onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return handleSaveDraft();

                  case 3:
                    _context2.next = 5;
                    return router.push(PAGE_HOME);

                  case 5:
                    _context2.next = 11;
                    break;

                  case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2["catch"](0);
                    errorDisplay.set();
                    throw _context2.t0;

                  case 11:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[0, 7]]);
          })),
          children: t('todo-promo-summary.do-this-later')
        })
      })]
    })]
  });
};
var SubscriptionCard = styled(Box).withConfig({
  componentId: "sc-78043e-0"
})(["&&{border-radius:", ";border:1.5px solid ", ";}"], th.getRadii('small'), th.getColor('sandMedium'));